<template>
  <div>
    <div class="w-100" @touchstart.stop @touchmove.stop>
      <ProductDetail :status="tabIndex" />
    </div>
  </div>
</template>

<script>
import ProductDetail from "./orderProduct/ProductDetail.vue";

export default {
  name: "ChatOrderProduct",
  components: { ProductDetail },
  data() {
    return {
      tabIndex: 0
    };
  }
};
</script>

<style lang="scss" scoped>
.tab-title {
  ::v-deep .nav-link,
  ::v-deep .nav-tabs,
  ::v-deep .nav-tabs .nav-link.active,
  ::v-deep .nav-link:hover {
    border: none !important;
    border-bottom: none !important;
  }
}
</style>
